import store from '../store/index'
export function setInterceptors(instance) {
  // Add a request interceptor
  instance.interceptors.request.use(
    function (config) {
      // Do something before request is sent

      config.headers.authorization = store.state.token
      return config
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  // Add a response interceptor
  instance.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    },
    function (error) {
      // 401/403: 토큰 만료·무효 → 세션 정리 후 로그인 리다이렉트
      // (이 백엔드는 토큰이 무효할 때 401 대신 403을 내려주는 경우가 있어,
      // 로그인된 것처럼 보이는데 모든 목록이 빈 채로 나오는 문제가 있었음)
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        sessionStorage.removeItem('token')
        if (window.location.pathname !== '/') {
          window.location.href = window.location.origin
        }
      }
      return Promise.reject(error)
    }
  )
  return instance
}
